import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

if (window.location.hostname.startsWith("www.")) {
  window.location.replace(window.location.href.replace("://www.", "://"));
}

const params = new URLSearchParams(window.location.search);
const attribution = {};
["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid"].forEach((k) => {
  const v = params.get(k);
  if (v) attribution[k] = v;
});
try {
  const existing = JSON.parse(sessionStorage.getItem("empire_attribution") || "{}");
  if (!existing.referrer && document.referrer && !document.referrer.startsWith(window.location.origin)) {
    attribution.referrer = document.referrer;
  }
  if (Object.keys(attribution).length) {
    sessionStorage.setItem("empire_attribution", JSON.stringify({ ...existing, ...attribution }));
  }
} catch {
  if (Object.keys(attribution).length) sessionStorage.setItem("empire_attribution", JSON.stringify(attribution));
}

import { TRACKING } from "@/config/tracking";

window.dataLayer = window.dataLayer || [];
function gtagBoot() { window.dataLayer.push(arguments); }
gtagBoot("consent", "default", {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  wait_for_update: 500,
});
if (TRACKING.GTM_ID) {
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(TRACKING.GTM_ID)}`;
  document.head.appendChild(gtmScript);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
